const data = [
    {
        id: 1,
        name: "Topfy",
        description: `Dashboard of your weekly top five spotify songs!`,
        features: ``,
        tech: "Spotify API, React.js, React - Router, React - Redux, Node.js",
        link:{
            code:"https://github.com/aditi028/topfy/",
            live:"https://topfysongs.netlify.app/"
        }
       
    },
    {
        id: 2,
        name: "Mynt",
        description: `Front-end Clone of an e-commerce web app.
provides facility to buy products online.`,
        features:`Explore products
Add items to the cart
Checkout items in the cart
Dummy stripe payment to place order`,
        tech: "React.js, React - Router, React - Redux, Stripe API, Firebase, Node.js",
        link:{
            code:"https://github.com/aditi028/mynt",
            live:"https://mynt-frontend.netlify.app"
        }
    },
    {
        id: 3,
        name: "Todo",
        description: `A to-do list web app.`,
        features:`Add, update and delete tasks
shows a list of completed and pending tasks
        `,
        tech: "React.js, Javascript, html, css",
        link:{
            code:"https://github.com/aditi028/todo",
            live:"https://todo-hq.netlify.app"
        }
    },
    {
        id: 4,
        name: "Notes",
        description: `A note-taking app.`,
        features:`create, update and delete notes
local storage support`,
        tech: "Javascript, html, css",
        link:{
            code:"https://github.com/aditi028/notes",
            live:"https://notes-hq.netlify.app"
        }
    },
    {
        id: 5,
        name: "Comments",
        description:`Interactive Comments Section Feature for Web Apps`,
        features:`add and delete comments
reply to another user`,
        tech: "Javascript, html, css",
        link:{
            code:"https://github.com/aditi028/comments",
            live:"https://interactive-comments-feature.netlify.app/"
        }
    }
];

export default data;